import React, { Fragment, useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { useHistory } from "react-router-dom";
import RenderIcons from "../../Assets/css/_icons/partner_icon/RenderIcons";
import { saveEmployeeDetails } from "../../store/service";
import * as ConfigurationActions from "../../store/configurationService/actions";
import { Notification } from "../common/Notification";
import UploadEmployee from "./UploadEmployee";
import { ApplicationState } from "../../store";
import { useDispatch, useSelector } from "react-redux";

function AddEmployee() {
    const history: any = useHistory();
    const dispatch = useDispatch();
    const routeLoading = useSelector((state: ApplicationState) => state.configurationState && (state.configurationState.loading || false));
    const [isLoading, setIsLoading] = useState(false);
    const [addMultipleEmployee, setMultipleEmployee] = useState(false);

    const licenseAvailable = history && history.location.state && history.location.state.licenseAvailable;

    const { register, errors, handleSubmit, watch, setError, clearErrors } = useForm({
        mode: "onChange",
        reValidateMode: "onChange",
    });

    const onSubmit = (employeeInfo: any) => {
        if (employeeInfo.FirstName.trim() && employeeInfo.LastName.trim()) {
            setIsLoading(true);
            saveEmployeeDetails({
                EmployeeList: [
                    {
                        ...employeeInfo,
                        FirstName: employeeInfo.FirstName.trim(),
                        LastName: employeeInfo.LastName.trim(),
                        Action: "",
                    },
                ],
            })
                .then((res) => {
                    setIsLoading(false);
                    if (res.hasError) {
                        Notification({
                            type: "error",
                            title: "Error",
                            message: res.errors[0],
                            duration: 5,
                        });
                    } else {
                        Notification({
                            type: "success",
                            title: "Success",
                            message: "Your employee has been added successfully!",
                            duration: 5,
                        });
                        history.goBack();
                    }
                })
                .catch((err) => {
                    setIsLoading(false);
                    Notification({
                        type: "error",
                        title: "Error",
                        message: err,
                        duration: 5,
                    });
                });
        } else {
            if (!employeeInfo.FirstName.trim()) {
                setError("FirstName", {
                    type: "required",
                    message: "",
                });
            }
            if (!employeeInfo.LastName.trim()) {
                setError("LastName", {
                    type: "required",
                    message: "",
                });
            }
        }
    };

    const goBack = (e: any) => {
        e.preventDefault();
        history.goBack();
    };

    useEffect(() => {
        if (!licenseAvailable) {
            history.goBack();
        }
    }, []);

    useEffect(() => {
        if (routeLoading) {
            dispatch(ConfigurationActions.actionCreators.setRouteLoading(false));
        }
    }, [dispatch, routeLoading]);

    return (
        <Fragment>
            <div className="row middle-xs">
                <div className="result-back-arrow-box">
                    <span className="btn-icon cursor-pointer" onClick={goBack} style={{ width: "1.5rem" }}>
                        <em className="las la-angle-left breach-back-arrow-icon"></em>
                    </span>
                </div>
                <div className="col-xs">
                    <h1 className="title-page" id="title-page">
                        Add New Employee
                    </h1>
                </div>
            </div>

            <div className="row" id="content">
                <div className="box offset-padding" style={{ width: "100%" }}>
                    <div className="box-header">
                        <div className="box-title-container">
                            <div className="box-title-icon" aria-hidden="true">
                                {addMultipleEmployee ? <em className="las la-user-friends"></em> : <RenderIcons iconName={"user"} />}
                            </div>
                            <div className="box-title-text has-actions">
                                {addMultipleEmployee ? (
                                    <>
                                        {" "}
                                        <h2 className="employee-title">Upload File</h2>
                                        <p className="padding-bottom-xs breach-exposure-desc f-14">
                                            {`To add your employees from a file upload you need to
											download the template file, fill it out for up to
											${licenseAvailable} employees, upload and submit.`}
                                        </p>
                                    </>
                                ) : (
                                    <h2 className="employee-title">Employee Information</h2>
                                )}
                            </div>
                        </div>
                    </div>
                    <div className={isLoading ? "box-content loading" : "box-content"}>
                        {addMultipleEmployee ? (
                            <UploadEmployee addMultipleEmployee={addMultipleEmployee} setMultipleEmployee={setMultipleEmployee} setIsLoading={setIsLoading} />
                        ) : (
                            <form onSubmit={handleSubmit(onSubmit)}>
                                <fieldset className="form-row inline">
                                    <div className="row">
                                        <div className="col-xs-12 col-sm-4 col-no-gutter">
                                            <legend className="legend-label">First Name</legend>
                                        </div>
                                        <div className="col-xs-12 col-sm-4 col-no-gutter">
                                            <div className="row">
                                                <div className="col-xs-12 col-no-gutter">
                                                    <div className={errors["FirstName"] ? "form-row row status-error" : "form-row row"}>
                                                        <div className="form-row row">
                                                            <div className="form-label sr-only col-xs-12 col-no-gutter">
                                                                <label htmlFor="label-first-name">First Name</label>
                                                            </div>
                                                            <div className="form-input col-xs-12 col-no-gutter">
                                                                <input
                                                                    type="text"
                                                                    className="inputbox"
                                                                    id="label-first-name"
                                                                    name="FirstName"
                                                                    ref={register({
                                                                        pattern: /^[a-zA-Z-'\s.]+$/,
                                                                        required: true,
                                                                    })}
                                                                    onBlur={() => {
                                                                        if (!watch("FirstName").trim().length) {
                                                                            setError("FirstName", {
                                                                                type: "pattern",
                                                                                message: "",
                                                                            });
                                                                        }
                                                                    }}
                                                                />
                                                                {errors.FirstName && errors.FirstName.type === "pattern" && (
                                                                    <span className="form-error">
                                                                        Please enter a first name that only uses letters, spaces, and the characters -'
                                                                    </span>
                                                                )}
                                                                {errors.FirstName && errors.FirstName.type === "required" && (
                                                                    <span className="form-error">First Name is required</span>
                                                                )}
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </fieldset>
                                <fieldset className="form-row inline">
                                    <div className="row">
                                        <div className="col-xs-12 col-sm-4 col-no-gutter">
                                            <legend className="legend-label">Last Name</legend>
                                        </div>
                                        <div className="col-xs-12 col-sm-4 col-no-gutter">
                                            <div className="row">
                                                <div className="col-xs-12 col-no-gutter">
                                                    <div className={errors["LastName"] ? "form-row row status-error" : "form-row row"}>
                                                        <div className="form-row row">
                                                            <div className="form-label sr-only col-xs-12 col-no-gutter">
                                                                <label htmlFor="label-last-name">Last Name</label>
                                                            </div>
                                                            <div className="form-input col-xs-12 col-no-gutter">
                                                                <input
                                                                    type="text"
                                                                    className="inputbox"
                                                                    id="label-last-name"
                                                                    name="LastName"
                                                                    ref={register({
                                                                        pattern: /^[a-zA-Z-'\s.]+$/,
                                                                        required: true,
                                                                    })}
                                                                    onBlur={() => {
                                                                        if (!watch("LastName").trim().length) {
                                                                            setError("LastName", {
                                                                                type: "pattern",
                                                                                message: "",
                                                                            });
                                                                        }
                                                                    }}
                                                                />
                                                                {errors.LastName && errors.LastName.type === "pattern" && (
                                                                    <span className="form-error">
                                                                        Please enter a last name that only uses letters, spaces, and the characters -'
                                                                    </span>
                                                                )}
                                                                {errors.LastName && errors.LastName.type === "required" && (
                                                                    <span className="form-error">Last Name is required</span>
                                                                )}
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </fieldset>
                                <fieldset className="form-row inline">
                                    <div className="row">
                                        <div className="col-xs-12 col-sm-4 col-no-gutter">
                                            <legend className="legend-label">Email Address</legend>
                                        </div>
                                        <div className="col-xs-12 col-sm-4 col-no-gutter">
                                            <div className="row">
                                                <div className="col-xs-12 col-no-gutter">
                                                    <div className={errors["Email"] ? "form-row row status-error" : "form-row row"}>
                                                        <div className="form-row row">
                                                            <div className="form-label sr-only col-xs-12 col-no-gutter">
                                                                <label htmlFor="label-email-address">Email Address</label>
                                                            </div>
                                                            <div className="form-input col-xs-12 col-no-gutter">
                                                                <input
                                                                    type="text"
                                                                    className="inputbox"
                                                                    id="label-email-address"
                                                                    name="Email"
                                                                    ref={register({
                                                                        pattern: /^\w+([-+.']\w+)*[\-]?@\w+([-.]\w+)*\.\w+([-.]\w+)*$/,
                                                                        required: !(watch("Email") || watch("SMSContact")),
                                                                    })}
                                                                    onChange={() => {
                                                                        if (watch("Email") || watch("SMSContact")) {
                                                                            clearErrors("Email");
                                                                        }
                                                                    }}
                                                                />
                                                                {errors.Email && errors.Email.type === "pattern" && (
                                                                    <span className="form-error">
                                                                        Please enter a valid email address including a "@" and "." For example:
                                                                        "janesmith123@gmail.com"
                                                                    </span>
                                                                )}
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </fieldset>
                                <fieldset className="form-row inline">
                                    <div className="row">
                                        <div className="col-xs-12 col-sm-4 col-no-gutter">
                                            <legend className="legend-label">Mobile Number</legend>
                                        </div>
                                        <div className="col-xs-12 col-sm-4 col-no-gutter">
                                            <div className="row">
                                                <div className="col-xs-12 col-no-gutter">
                                                    <div className={errors["SMSContact"] ? "form-row row status-error" : "form-row row"}>
                                                        <div className="form-row row">
                                                            <div className="form-label sr-only col-xs-12 col-no-gutter">
                                                                <label htmlFor="label-mobile-number">Mobile Number</label>
                                                            </div>
                                                            <div className="form-input col-xs-12 col-no-gutter">
                                                                <input
                                                                    type="text"
                                                                    className="inputbox"
                                                                    name="SMSContact"
                                                                    ref={register({
                                                                        pattern: /^[(]?\d{3}[)]?[-.\s]?\d{3}[-.\s]?\d{4}$/,
                                                                    })}
                                                                    id="label-mobile-number"
                                                                    onChange={() => {
                                                                        if (watch("Email") || watch("SMSContact")) {
                                                                            clearErrors("Email");
                                                                        }
                                                                    }}
                                                                />
                                                                {errors.SMSContact && errors.SMSContact.type === "pattern" && (
                                                                    <span className="form-error">Please provide a Mobile number in a valid 10 number format</span>
                                                                )}

                                                                {errors.Email && errors.Email.type === "required" && !watch("Email") && !watch("SMSContact") && (
                                                                    <span className="form-error">Either Email or Mobile number is missing or invalid.</span>
                                                                )}
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </fieldset>
                                <div className="row between-xs pt-2">
                                    <div className="col-xs-6 col-sm-6 col-no-gutter flex-grow-null">
                                        <button
                                            type="button"
                                            className="btn-default btn-secondary-outline"
                                            onClick={() => setMultipleEmployee(!addMultipleEmployee)}
                                        >
                                            <span className="btn-text">Add Multiple Employees</span>
                                        </button>
                                    </div>
                                    <div className="col-xs-6 col-sm-6 col-no-gutter flex-grow-null flex-end">
                                        <button type="submit" className="btn-default btn-link btn-min-width" onClick={goBack}>
                                            <span className="btn-text">Cancel</span>
                                        </button>
                                        <button
                                            type="submit"
                                            className="btn-default btn-primary btn-min-width"
                                            onClick={() =>
                                                window.addToDataLayer({
                                                    event: "Button Add Employee Click",
                                                })
                                            }
                                            disabled={Object.keys(errors).length !== 0}
                                        >
                                            <span className="btn-text">Add Employee</span>
                                        </button>
                                    </div>
                                </div>
                            </form>
                        )}
                    </div>
                </div>
            </div>
        </Fragment>
    );
}

export default AddEmployee;
